import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';
import { PasswordValidationCallbacks } from "@/services/misc/functions/ValidationFunctions";

export class CreateDatabaseForm {
  public name: string = '';
  public server: string = '';
  public websiteId: number = -1;
  public password: string = '';
  public passwordConf: string = '';

  public rules: { [key: string]: FormValidationFunction[] } = {
    name: [
      (v: string) => !!v || 'Name is required',
      (v: string) => v.length <= 24 || 'Name can be at most 24 characters',
      (v: string) => v.length >= 3 || 'Name has to be at least 3 characters',
      (v: string) => !v || /^[a-zA-Z0-9]+$/.test(v) || 'Name must contain only letters and numbers',
    ],
    server: [
      (v: string) => !!v || 'Server is required',
    ],
    websiteId: [
      (v: number) => !!v || 'Website is required',
      (v: number) => v > 0 || 'Website is required',
    ],
    password: [
      (v: string) => !!v || 'Password is required',
      ...PasswordValidationCallbacks,
    ],
  };
}
